import React from "react";
import SupportHeader from "../../components/support/supportHeader";
import SupportForm from "../../components/support/supportForm";
import Footer from "../../components/footer/Footer";

const Support = () => {
  return (
    <>
      <SupportHeader />
      <SupportForm />
      <Footer />
    </>
  );
};

export default Support;
